<template>
  <div>
    <div class="loan-container">
      <h4 class="header mt-5">Loan Requests</h4>
      <p class="subText mb-5">
        Loan requests allows you to track and manage all requests received
        across all of your products
      </p>

      <div class="loan-container__header-card pt-5 mb-5">
        <div class="header">
          <div class="header-left">
            <h2 class="text">Overview</h2>
            <p class="sub-text">
              Here’s a quick overview of what’s happening
            </p>
          </div>
          <div class="filter__wrap" @click.stop>
            <div
              class="filter-selected"
              @click="showFilterMenu = !showFilterMenu"
            >
              {{ summaryFilter.text }}
              <svgicon
                icon="drop-down"
                :class="`filter-icon ${showFilterMenu && 'active'}`"
              ></svgicon>
            </div>
            <ul
              v-if="showFilterMenu"
              :class="`header-filter ${showFilterMenu && 'active'}`"
            >
              <li
                v-for="(el, index) in filterOption"
                :key="index"
                @click="handleFilter(el)"
              >
                {{ el.text }}
              </li>
            </ul>
          </div>
        </div>

        <div class="inner-border">
          <div class="inner-border__four_grid_container pb-lg-4">
            <div class="border-right px-4 mb-5">
              <div class="border-bottom">
                <p>ALL REQUESTS</p>

                <h4>{{ loanSummary && loanSummary.totalLoanRequests }}</h4>

                <p>This month</p>
              </div>
            </div>

            <div class="border-right px-4  mb-5">
              <div class="border-bottom">
                <p class="green-text">APPROVED REQUESTS</p>

                <h4>{{ loanSummary && loanSummary.totalApprovedRequests }}</h4>

                <p>This month</p>
              </div>
            </div>

            <div class="border-right px-4  mb-5">
              <div class="border-bottom">
                <p class="red-text">PENDING REQUESTS</p>

                <h4>{{ loanSummary && loanSummary.totalPendingRequests }}</h4>

                <p>This month</p>
              </div>
            </div>

            <div class="px-4 mb-5">
              <div class="border-bottom">
                <p class="red-text">DECLINED REQUESTS</p>

                <h4>{{ loanSummary && loanSummary.totalDeclinedRequests }}</h4>

                <p>This month</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="loan-container__header-card">
        <div class="header">
          <div class="filter__wrap" @click.stop>
            <div
              class="filter-selected"
              @click="showRequestFilterMenu = !showRequestFilterMenu"
            >
              {{ requestFilter.text }}
              <svgicon
                icon="drop-down"
                :class="`filter-icon ${showRequestFilterMenu && 'active'}`"
              ></svgicon>
            </div>
            <ul
              v-if="showRequestFilterMenu"
              :class="`header-filter ${showRequestFilterMenu && 'active'}`"
            >
              <li
                v-for="(el, index) in requestFilterOption"
                :key="index"
                @click="handleRequestTableFilter(el)"
              >
                {{ el.text }}
              </li>
            </ul>
          </div>
        </div>

        <div class="list-of-loans-table-container">
          <table class="list-of-loans-table">
            <thead>
              <tr>
                <th class="list-of-loans-table-heading">
                  ID
                </th>
                <th class="list-of-loans-table-heading">
                  Date
                </th>
                <th class="list-of-loans-table-heading">
                  AMOUNT
                </th>
                <th class="list-of-loans-table-heading">
                  STATUS
                </th>
                <th class="list-of-loans-table-heading">
                  ACTION
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(loan, index) in listOfLoans" :key="index">
                <td class="list-of-loans-table-data">
                  {{ loan && loan.trackingCode }}
                </td>
                <td class="list-of-loans-table-data">
                  {{ loan && loan.createdAt | formatDate }}
                </td>
                <td class="list-of-loans-table-data">
                  ₦
                  {{
                    loan &&
                      new Intl.NumberFormat().format(
                        Number(loan.requestedAmount)
                      )
                  }}
                </td>
                <td class="list-of-loans-table-data">
                  <StatusBadge :status="loan && loan.status" />
                </td>
                <td class="list-of-loans-table-data">
                  <b-dropdown
                    id="dropdown-right"
                    right
                    size="lg"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <svgicon
                        icon="table-menu"
                        class="dashboard__listing-table-menu"
                      ></svgicon>
                    </template>
                    <b-dropdown-item :to="`/loan-details/${loan.id}`"
                      >View</b-dropdown-item
                    >
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>

          <div
            class="dashboard__pagination"
            v-if="listOfLoans && listOfLoans.length > 0"
          >
            <b-pagination
              pills
              v-model="currentPage"
              :total-rows="totalLoans"
              :per-page="pageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import { getAllLoans, getLoanSummary } from "../../../services/loans";
import StatusBadge from "../general/statusBadge.vue";
export default {
  name: "loans",
  components: {
    loader,
    StatusBadge
  },
  data() {
    return {
      filter: { text: "All", value: "all" },
      requestFilter: { value: "all", text: "All Request" },
      showFilterMenu: false,
      showRequestFilterMenu: false,
      showRequestFilterTableMenu: false,
      currentPage: 1,
      pageSize: 10,
      count: 0,
      pages: 0,
      loader: false,
      listOfLoans: [],
      loanSummary: {},
      totalLoans: 0,
      summaryFilter: { text: "All", value: "all" }
    };
  },
  watch: {
    $route() {
      this.handleAllLoans();
    }
  },
  methods: {
    handleFilter(value) {
      this.summaryFilter = value;
      this.showFilterMenu = false;
      this.handleGetLoanSummary();
    },
    handleRequestTableFilter(value) {
      this.requestFilter = value;
      this.showRequestFilterMenu = false;
      this.handleAllLoans();
    },

    handlePagination(value) {
      if (value === 1) {
        this.pages = 0;
      } else {
        this.pages = (value - 1) * this.pageSize;
      }
      this.currentPage = value;
      this.$router.push({ query: { page: value } });
    },

    handleGetLoanSummary() {
      const payload = {
        period: this.summaryFilter.value
      };

      getLoanSummary(payload)
        .then(res => {
          this.loanSummary = res.data;
        })
        .catch(err => {
          return err;
        });
    },

    clickaway() {
      if (this.showFilterMenu) {
        this.showFilterMenu = false;
      }

      if (this.showRequestFilterMenu) {
        this.showRequestFilterMenu = false;
      }
    },

    requestClickaway() {
      if (this.showFilterMenu) {
        this.showFilterMenu = false;
      }

      if (this.showRequestFilterMenu) {
        this.showRequestFilterMenu = false;
      }
    },

    handleAllLoans() {
      this.loader = true;
      const payload = {
        page: this.currentPage,
        limit: this.pageSize
      };

      if (this.requestFilter.value && this.requestFilter.value !== "all") {
        payload.status = this.requestFilter.value;
      }

      getAllLoans(payload)
        .then(res => {
          this.listOfLoans = res.data.loans;
          this.totalLoans = res.data.totalLoan;
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.loader = false;
        });
    }
  },
  async mounted() {
    this.currentPage = this.$route.query.page || 1;
    window.addEventListener("click", this.clickaway);
    window.addEventListener("click", this.requestClickaway);

    await Promise.all([this.handleAllLoans(), this.handleGetLoanSummary()]);
  },
  destroyed() {
    window.removeEventListener("click", this.clickaway);
    window.removeEventListener("click", this.requestClickaway);
  },
  computed: {
    filterOption() {
      return [
        { value: "all", text: "All" },
        { value: "monthly", text: "Month" },
        { value: "quarterly", text: "Quarter" },
        { value: "biannually", text: "Biannual" },
        { value: "yearly", text: "Year" }
      ];
    },

    requestFilterOption() {
      return [
        { value: "all", text: "All" },
        { value: "pending", text: "Pending" },
        { value: "approved", text: "Approved" },
        { value: "disbursed", text: "Disbursed" },
        { value: "cancelled", text: "Cancelled" }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: auto;
  margin-bottom: 16px;

  .filter__wrap {
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #0f0c3d;
    cursor: pointer;
    user-select: none;
    margin-left: auto;

    .filter-selected {
      background: #fafafe;
      border: 0.4px solid #99a4e1;
      border-radius: 22px;
      padding: 14px;
      width: 128px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 2px -1px 8px rgba(0, 0, 0, 0.16);

      .filter-icon {
        fill: none;
        width: 10px;
        stroke: rgba(0, 0, 0, 0.4);
        stroke-width: 20px;
        margin-left: 4px;
        transition: all ease 0.25s;

        &.active {
          transform: rotate(180deg);
        }
      }
    }

    .header-filter {
      position: absolute;
      border: 0.4px solid #99a4e1;
      width: 100%;
      border-radius: 6px;
      top: 105%;
      z-index: 2;
      background: white;
      box-shadow: 4px 6px 16px rgba(0, 0, 0, 0.16);

      li {
        padding: 12px 6px;
        border-bottom: 0.4px solid #99a4e1;

        &:last-child {
          border: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/loanRequest.vue